module.exports = __webpack_public_path__ + "static/media/signage-indoor-img75.a17ca692.jpg";